import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import TeamSection from '../../components/TeamSection/TeamSection';
import Footer from '../../components/footer/Footer';
import Newslatter from '../../components/Newslatter/Newslatter';
import { useLanguage } from '../../i18n/LanguageContext';


const TeamPage =() => {
    const { t } = useLanguage();

    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={t('teachers.pageTitle')} pagesub={t('teachers.pageSubTitle')}/>
            <TeamSection tClass={'wpo-team-section-s3'}/>
            <Newslatter/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default TeamPage;
